module.exports = __webpack_public_path__ + "static/media/vpsports.43071bc7.jpg";